"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.selectDeliveryOptionsPath = exports.selectDeliveryOptions = void 0;
const utils_1 = require("@invivodf/utils");
const utils_2 = require("../../../utils");
const selectDeliveryOptions = (client) => async ({ checkoutId, consignments }) => {
    try {
        const response = await client.put((0, exports.selectDeliveryOptionsPath)(checkoutId), {
            consignments
        });
        return utils_1.Result.success(response.data);
    }
    catch (error) {
        if ((0, utils_2.isFunctionalApiError)(error)) {
            return utils_1.Result.failure({
                code: error.body.code,
                message: error.body.message
            });
        }
        throw error;
    }
};
exports.selectDeliveryOptions = selectDeliveryOptions;
const selectDeliveryOptionsPath = (checkoutId) => `/v2/bff/appro/checkouts/${checkoutId}/delivery-options`;
exports.selectDeliveryOptionsPath = selectDeliveryOptionsPath;
